import { render, staticRenderFns } from "./Step0.vue?vue&type=template&id=56e2d6cb&scoped=true&"
import script from "./Step0.vue?vue&type=script&lang=js&"
export * from "./Step0.vue?vue&type=script&lang=js&"
import style0 from "./Step0.vue?vue&type=style&index=0&id=56e2d6cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_7gprpqnc7s6aitlohrfuswmoxa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e2d6cb",
  null
  
)

export default component.exports